<template>
  <b-card :img-src="img" class="h-100">
    <b-card-title class="mt-lg-3" style="font-weight: bold; height: 60px">
      {{ title }}
    </b-card-title>
    <div class="mt-auto">
      <b-card-text> {{ body }} </b-card-text>
    </div>
    <template #footer transparent>
      <b-button
        squared
        style="background-color: black"
        class="main-button"
        :href="link"
        target="_blank"
      >
        {{ link_text }}</b-button
      >
    </template>
  </b-card>
</template>

<script>
export default {
  props: ["img", "title", "body", "link", "link_text"],
};
</script>

<style scoped>
.card > img {
  height: 250px;
  width: auto;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/atHomeCard.vue